exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment-container[data-v-3e5e61df] {\n  border: 1px solid rgba(100, 100, 100, 0.6);\n  min-height: 30px;\n}", ""]);

// exports
